import React from 'react';
import { ClockIcon } from 'lucide-react';
export function UrgencyNotice() {
  return <section className="max-w-lg mx-auto px-4 pb-8" data-id="element-138">
      <div className="bg-gradient-to-r from-peach-coral/20 to-rose-gold/20 rounded-xl p-5 border border-peach-coral/30" data-id="element-139">
        <div className="flex items-start gap-3" data-id="element-140">
          <ClockIcon className="w-5 h-5 text-peach-coral flex-shrink-0 mt-0.5" data-id="element-141" />
          <div data-id="element-142">
            <h3 className="text-base font-semibold text-deep-cocoa mb-2" data-id="element-143">
              Oferta especial de lanzamiento
            </h3>
            <p className="text-sm text-deep-cocoa/80 leading-relaxed" data-id="element-144">
              Este precio de $190 MXN es promocional. Pronto subirá a su precio
              regular de $497 MXN. Si ya tomaste la decisión, este es el mejor
              momento para asegurar tu acceso.
            </p>
          </div>
        </div>
      </div>
    </section>;
}